import {Component, OnInit, ViewChild} from "@angular/core";
import {IEmployeesService} from "../../../../domain/employees/IEmployeesService";
import {Employee} from "../../../../../../../server/src/base/entities/employee/Employee";
import {ErrorPopupComponent} from "../../generic/popup/errorPopup/errorPopup";
import {Employees} from "../../../../../../../server/src/base/entities/employee/Employees";

@Component({
    styleUrls: ['./employees.scss'],
    templateUrl: './employees.html'
})
export class AdminEmployeesComponent implements OnInit{

    employees:Array<Employee> = [];
    employeeToAdd:Employee = new Employee();
    private picture:File = null;
    @ViewChild(ErrorPopupComponent) errorPopupComponent:ErrorPopupComponent;

    constructor(private employeeService:IEmployeesService){
        this.employeeToAdd.picture = 'a';
    }

    ngOnInit(): void {
        this.employeeService.GetAll().then(employees => {
            this.employees = employees.Value();
        })
    }

    Remove(employee:Employee){
        this.employeeService.Remove(employee).then(() => {
            this.employees.splice(this.employees.indexOf(employee));
        });
    }

    pictureChosen(picture:File){
        this.picture = picture;
    }

    addEmployee(){
        if(this.picture == null){
            this.errorPopupComponent.Open("Création d'employé", "Vous devez définir une photo");
        }
        else{
            this.employeeService.Add(this.employeeToAdd, this.picture).then(employee => {
                this.employees.push(employee);
                this.employeeToAdd = new Employee();
            });
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/employees/employees.ts